import { InformationColorSvgComponent } from '../../../svg/information-color-svg/information-color-svg.component';
import { MapfreButtonComponent } from '../../individual-components/inputs/mapfre-button/mapfre-button.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, Input , NO_ERRORS_SCHEMA } from '@angular/core';

@Component({
  standalone: true,
  schemas: [NO_ERRORS_SCHEMA],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, NgSelectModule, MapfreButtonComponent, InformationColorSvgComponent],
  selector: 'mapfre-generic-information-template',
  templateUrl: './generic-information-template.component.html'
})
export class GenericInformationTemplateComponent {
  @Input() headerImageURL:      string;
  @Input() backButtonUrl:       string;
  @Input() additionalClasses:   string;
  @Input() type:                string;
}
